import { Link } from '@tanstack/react-router';
import { cn } from '@/lib/utils';
import type { BuscaLista } from './tipos';

const BASE = 'flex h-[30px] items-center rounded-lg px-3 text-small';

/** Lista | Kanban (docs/design/Pipeline.dc.html). Leva busca, cliente, periodo e "abaixo da meta" de uma vista para a outra. */
export function AlternarVisao({ atual, busca }: { atual: 'lista' | 'kanban'; busca: BuscaLista }) {
  const { q, clienteId, dataDe, dataAte, abaixo } = busca;
  const compartilhado: BuscaLista = { ...(q ? { q } : {}), ...(clienteId ? { clienteId } : {}), ...(dataDe ? { dataDe } : {}), ...(dataAte ? { dataAte } : {}), ...(abaixo ? { abaixo } : {}) };
  return (
    <div role="tablist" aria-label="Visualização" className="flex gap-1 rounded-[10px] bg-line-soft p-[3px]">
      <Link
        to="/vender/orcamentos"
        search={compartilhado}
        role="tab"
        aria-selected={atual === 'lista'}
        className={cn(BASE, atual === 'lista' ? 'bg-card font-semibold shadow-[0_1px_2px_rgba(0,0,0,0.08)]' : 'text-ink-secondary hover:text-ink')}
      >
        Lista
      </Link>
      <Link
        to="/vender/orcamentos/kanban"
        search={compartilhado}
        role="tab"
        aria-selected={atual === 'kanban'}
        className={cn(BASE, atual === 'kanban' ? 'bg-card font-semibold shadow-[0_1px_2px_rgba(0,0,0,0.08)]' : 'text-ink-secondary hover:text-ink')}
      >
        Kanban
      </Link>
    </div>
  );
}
